module.exports = __webpack_public_path__ + "static/media/CAN_logo.bc845d43.jpg";